import React from "react";
import { TagIcon } from "../../utils/tagIcons";
import { timeAgo } from "../../utils/relativeTime";
import { useSiteAlerts } from "./SiteAlertsContext";
import { familyOf, inkOn } from "./alertDisplay";
import "./SiteAlerts.css";

/**
 * Full-width alert strips pinned above the top bar — the high-visibility
 * style meant for emergencies and must-see notices. Renders every active
 * alert with display_style === 'banner'. Non-dismissable banners have no ×;
 * they stay until an admin ends them in Settings > Alert Center.
 */
export default function SiteAlertBanners() {
  const { alerts, dismiss } = useSiteAlerts();
  const banners = alerts.filter((a) => a.display_style === "banner");
  if (banners.length === 0) return null;

  return (
    <div className="site-alert-banners" role="status" aria-live="polite">
      {banners.map((alert) => {
        const family = familyOf(alert);
        const ink = inkOn(family.vivid);
        return (
          <div
            key={alert.id}
            className="site-alert-banner"
            style={{ background: family.vivid, color: ink }}
          >
            <span className="site-alert-banner-icon" aria-hidden="true">
              <TagIcon name={family.icon} size={16} strokeWidth={2.2} />
            </span>
            <span className="site-alert-banner-text">{alert.message}</span>
            <span className="site-alert-banner-time">
              Posted {timeAgo(alert.published_at)}
            </span>
            {alert.dismissable && (
              <button
                type="button"
                className="site-alert-banner-close"
                style={{ color: ink }}
                onClick={() => dismiss(alert.id)}
                aria-label="Dismiss alert"
                title="Dismiss"
              >
                ×
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
